import { getSessionData } from "../../../utils/helper";
import Footer from "../../Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import CustomDialog from "../CustomDialog";

const Welcome = () => {
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const viewRecords = () => {
    setShowConfirmation(true);
  };

  const proceedToRecords = () => {
    navigate("/record");
  };

  const viewDashboard = () => {
    navigate("/dashboard");
  };

  const userInfo = getSessionData();

  return (
    <>
      <div className="welcomeContainer">
      <div className="welcomeHeader">
        <div>Welcome back {userInfo?.firstName},</div>
        <div>Where do you want to get started today?</div>
      </div>
      <div className="card-container">
        <div className="card">
          <h2>Text Sentinel Records</h2>
          <div className="recordActions">
            <p>Go here to take the following actions:</p>
            <ul>
              <li>View records</li>
              <li>Create a sample of records</li>
              <li>Perform a review</li>
            </ul>
          </div>
          <div className="button-container">
            <button className="action-btn" onClick={viewRecords}>
              Review Records
            </button>
          </div>
        </div>
        <div className="card">
          <h2>Text Sentinel Performance Dashboard</h2>
          <div className="performanceDashboard">
            <p className="highlight">
              Go here to access Text Sentinel statistics.
            </p>
            <div className="actions">
              <p>In the dashboard you can filter for the following:</p>
              <ul>
                <li>PV records (passed/failed)</li>
                <li>PCO records (passed/failed)</li>
                <li>Not sampled records</li>
              </ul>
            </div>
          </div>
          <div className="button-container">
            <button className="action-btn" onClick={viewDashboard}>
              View Dashboard
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    {showConfirmation && (
      <CustomDialog
        title="Advisory"
        content="As a reviewer, you are responsible for the final outcome of all free-text reviews in Text Sentinel. Please ensure accuracy and completeness before submission."
        onClose={() => setShowConfirmation(false)}
        onAccept={proceedToRecords}
        acceptButtonLabel="I acknowledge"
        showCancelButton={false}
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
      />
    )}
    </>
  );
};

export default Welcome;
